
import { NavLink } from "react-router-dom";
import ReportsNotFoundSvgComponent from "../../assets/svg-components/not-found/reports";
import './index.scss';


export default function ReportsNotfoundPopup(props:any) {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
        {/* <img
            src="/images/page-not-found/reports.svg"
            className="not-found-image img-fluid not-found-image-reports"
          /> */}
          <div className="not-found-image img-fluid not-found-image-reports">
            <ReportsNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-reports">No reports are configured for the provided module. Please click the button below to create a new report.</p>
          <button className='btn btn-primary btn-add-no-record' onClick={() => props.handleAddFun()}>
            <div className="d-flex align-items-center color-white" >
              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z" fill="#ffffff"></path></svg>
                Create New
            </div>
          </button>
        </div>
      </div>
    </>
  );
}
